import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ariaDescribedByIds } from '@rjsf/utils';
/** The `TextareaWidget` is a widget for rendering input fields as textarea.
 *
 * @param props - The `WidgetProps` for this component
 */

function TextareaWidget(_ref) {
  var id = _ref.id,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      required = _ref.required,
      disabled = _ref.disabled,
      readonly = _ref.readonly,
      _ref$autofocus = _ref.autofocus,
      autofocus = _ref$autofocus === void 0 ? false : _ref$autofocus,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var handleChange = useCallback(function (_ref2) {
    var value = _ref2.target.value;
    return onChange(value === '' ? options.emptyValue : value);
  }, [onChange, options.emptyValue]);
  var handleBlur = useCallback(function (_ref3) {
    var target = _ref3.target;
    return onBlur(id, target && target.value);
  }, [onBlur, id]);
  var handleFocus = useCallback(function (_ref4) {
    var target = _ref4.target;
    return onFocus(id, target && target.value);
  }, [id, onFocus]);
  return _jsx("textarea", {
    id: id,
    name: id,
    className: 'form-control',
    value: value ? value : '',
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    readOnly: readonly,
    autoFocus: autofocus,
    rows: options.rows,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    "aria-describedby": ariaDescribedByIds(id)
  });
}

TextareaWidget.defaultProps = {
  autofocus: false,
  options: {}
};
export default TextareaWidget;